<template>
  <div class="district-based-resources">
    <div class="district-based-resources-top">
        <div class="title">校本资源</div>
        <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
        <div class="district-based-resources-tips">
          <div class="build">
            <div class="tips"></div>
            <div class="name">建设</div>
          </div>
          <div class="quote">
            <div class="tips"></div>
            <div class="name">引用</div>
          </div>
        </div>
    </div>
    <div class="district-based-resources-number">
        <div class="number-left">
            <div class="tip">
                <div class="left-bg"></div>
                教材同步
            </div>
            <div class="number-item">
                <div class="name">建设总量</div>
                <!-- <div class="number">1503</div> -->
                <count-up
                    class="infor-card-count user-created-count number"
                    :id-name="`code_建设总量1`"
                    :end-val="1503"
                    color="#FFFFFF"
                    countSize="16px"
                    :countWeight="700"
                    :isConvert="-1"
                    style="height:100%;"
                >
                </count-up>
            </div>
            <div class="number-item">
                <div class="name">引用总量</div>
                <!-- <div class="number">175840</div> -->
                <count-up
                    class="infor-card-count user-created-count number"
                    :id-name="`code_引用总量1`"
                    :end-val="175840"
                    color="#FFFFFF"
                    countSize="16px"
                    :countWeight="700"
                    :isConvert="1"
                    style="height:100%;"
                >
                </count-up>
            </div>
            <div class=""></div>
        </div>
        <div class="number-right">
            <div class="tip">
                <div class="left-bg"></div>
                专题资源
            </div>
            <div class="number-item">
                <div class="name">建设总量</div>
                <count-up
                    class="infor-card-count user-created-count number"
                    :id-name="`code_建设总量2`"
                    :end-val="1262"
                    color="#FFFFFF"
                    countSize="16px"
                    :countWeight="700"
                    :isConvert="-1"
                    style="height:100%;"
                >
                </count-up>
            </div>
            <div class="number-item">
                <div class="name">引用总量</div>
                <count-up
                    class="infor-card-count user-created-count number"
                    :id-name="`code_引用总量2`"
                    :end-val="159840"
                    color="#FFFFFF"
                    countSize="16px"
                    :countWeight="700"
                    :isConvert="1"
                    style="height:100%;"
                >
                </count-up>
            </div>
        </div>

    </div>
    <div class="district-based-resources-echarts">
        <div class="echarts-left">
          <div id="districtbaseLeftEchartsId" style="width: 100%;height: 100%"></div>
        </div>
        <div class="echarts-right">
          <div id="districtbaseRightEchartsId" style="width: 100%;height: 100%"></div>
        </div>
    </div>
    <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
    <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
    <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
    <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
  </div>
</template>
<script>
import * as echarts from 'echarts';
import CountUp from "@/components/countUp.vue";
export default {
  name: 'district-based-resources',
  components:{
    CountUp
  },
  data() {
    return {

    }
  },
  methods: {
    initEcharts(dom,nameList,dataList1,dataList2){
      // let dom = document.getElementById('districtbaseLeftEchartsId')
      let myChart = echarts.init(dom)
      let option = {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            // var relVal =params[0].name +
            //       "</br>" +
            //       params[0].marker +
            //       "建设量" + 
            //       params[0].value +
            //       "个" +
            //       "</br>" +
            //       params[1].marker +
            //       "引用量" +
            //       params[1].value +
            //       "个"
            var relVal = `<span style="color: #ffffff;">${params[0].name}</span></br><span style="color: #6EA0D3;">${params[0].marker}建设量：${params[0].value}个</span></br><span style="color: #6EA0D3;">${params[1].marker}引用量：${params[1].value}个</span>`
            return relVal;
            // return '<span style="color: red;">%c</span><span style="color: blue;"> vs %c</span><span style="color: green;"> (%d)</span>';
          },
          color:"#2773e6"
        },
        // #2773e6
        grid: {
          left: "0px",
          right: "40px",
          bottom: "20px",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: nameList,
          axisLabel: {
            interval: 0,
            color:"#6EA0D3",
            textStyle: {
              color: "#999",
              fontSize: "16px",
            },
          },
          axisTick: {
            alignWithLabel: true,
            show:false,
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: "#D6D6D6",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLine: {
            show: false,
            lineStyle: {
              color: "#D6D6D6",
            },
          },
          axisTick: {
            show:false,
          },
          axisLabel: {
            show: true,
            verticalAlign: "middle",
            color:"#6EA0D3",
            textStyle: {
              color: "#999",
            },
          },
          // data:[],
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            data: dataList1,
            type: "bar",
            name: "建设",
            color: "#2B7FFF",
            barMaxWidth: 16,
            // label: {
            //   normal: {
            //     show: true,
            //     position: "top",
            //     color: "#000000",
            //   },
            // },
            itemStyle: {
              borderRadius: [3, 3, 0, 0],
            },
          },
          {
            data:dataList2,
            type: "bar",
            name: "引用",
            color: "#27CDE6",
            barMaxWidth: 16,
            // label: {
            //   normal: {
            //     show: true,
            //     position: "top",
            //     color: "#000000",
            //   },
            // },
            itemStyle: {
              borderRadius: [3, 3, 0, 0],
            },
          },
        ],
      };
      option && myChart.setOption(option)
    }
  },
  mounted(){
    //左侧
    this.initEcharts(document.getElementById('districtbaseLeftEchartsId'),["语文", "数学", "英语","物理","化学","生物","科学"],[700,725,750,775,800,825,850],[650,675,700,725,750,775,800]);
     //左侧
     this.initEcharts(document.getElementById('districtbaseRightEchartsId'),["心理健康", "安全教育", "课后服务","家园共育"],[700,750,800,850],[675,700,750,775]);
  }
}
</script>
<style lang='scss' scoped>
.district-based-resources{
    width: 100%;
    height: 350px;
    padding: 0 15px;
    border: 1px solid #053882;
    // background: rgba(6,17,52,0.8);
    // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
    position: relative;
    margin-bottom: 20px;
    .district-based-resources-top{
        position: relative;
        text-align: center;
        margin-bottom: 15px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
        .district-based-resources-tips{
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 10px;
          display: inline-flex;
          justify-content: space-between;
          .build,.quote{
            display: flex;
            align-content: center;
            display: inline-block;
            .tips{
              display: inline-block;
              width: 9px;
              height: 9px;
              background: #2B7FFF;
              border-radius: 2px;
              margin-right: 5px;
            }
            .name{
              display: inline-block;
              font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #6EA0D3;
            }
          }
          .quote{
            margin-left: 20px;
            .tips{
              background: #27CDE6;
            }
          }
        }
    }
    .district-based-resources-number{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .number-left{
            width: 50%;
            display: flex;
            align-items: center;
        }
        .number-right{
            width: 50%;
            display: flex;
            align-items: center;
        }
        .tip{
            .left-bg{
                width: 14px;
                height: 14px;
                background: linear-gradient(90deg, #09132A, #24C4DC);
                margin-right: 5px;
            }
            font-size: 18px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #27CDE6;
            margin-right: 20px;
            display: flex;
            align-items: center;
        }
        .number-item{
            margin-right: 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .name{
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #7ABFDB;
            }
            .number{
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FFFFFF;
                margin-left: 8px;
            }
        }
    }
    .district-based-resources-echarts{
      display: flex;
      height: calc(100% - 80px);
      .echarts-left{
        width: 53%;
        height: 100%;
      }
      .echarts-right{
        width: 47%;
        height: 100%;
      }
    }
    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
}
</style>